import { Pipe, PipeTransform } from '@angular/core';
import { Icon, IconItem } from '@sb/library/base';
import { PaymentSourceDisplayItem, PaymentSourceType } from '@sb/library/data-models';

@Pipe({name: 'paymentSourceIcon'})
export class PaymentSourceIconPipe implements PipeTransform {

    transform(paymentSource: PaymentSourceDisplayItem): { Icon: IconItem } {
        if (paymentSource.Type === PaymentSourceType.BankAccount) {
            return { Icon: Icon.Common.University };
        } else if (paymentSource.Type === PaymentSourceType.CreditCard) {
            return { Icon: Icon.Payment.CreditCard };
        } else if (paymentSource.Type === PaymentSourceType.StripeLink) {
            return { Icon: Icon.Payment.CCStripe };
        } else if (paymentSource.Type === PaymentSourceType.PayPal) {
            return { Icon: Icon.Payment.PayPal };
        } else if (paymentSource.Type === PaymentSourceType.Venmo) {
            return { Icon: Icon.Payment.Venmo };
        } else if (paymentSource.Type === PaymentSourceType.Klarna) {
            return { Icon: Icon.Payment.Klarna };
        }

        throw Error("Unknown payment source type.");
    }
}
